// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BuildingPermissionCertificate.css */

.certificate-container {
  max-width: 1200px;
  margin: 2.5% 5% 5% 5%;
  padding: 0px 20px;
  font-family: 'Times New Roman', Times, serif;
  background-color: #f8f9fa;
  min-height: 80vh;
  border: 8px solid #29196f; 
}

.certificate-header {
  text-align: center;
  margin-bottom: 4px;
  border-bottom: 3px double #333;
  /* padding-bottom: 20px; */
  position: relative;
  margin-top: 2px;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 70px;
  position: relative;
  margin-top: 0px; 
}

/* LOGO STYLES */
.left-logo, .right-logo {
  position: absolute;
  top: 0;
  width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.left-logo {
  left: 0;
}

.right-logo {
  right: 0;
  
  
  justify-content: flex-end;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 5px;
}

.right-logo .logo-container {
  gap: 12px;
  /* padding: 10px; */
}

.logo-star {
  height: 50px;
  width: 50px;
  object-fit: contain;
  display: block;
}

.right-logo img {
  /* height: 120px; */
  width: auto;
  max-width: 250px;
  object-fit: contain;
  display: block;
}

.logo-text, .ipdc-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 150px;
}

.ipdc-text {
  max-width: 300px;
}

.logo-text p, .ipdc-text p {
  margin: 0;
  line-height: 1.2;
  color: #2c3e50;
  font-weight: 500;
}

.logo-text p {
  font-size: 11px;
}

.ipdc-text p {
  font-size: 13px;
  line-height: 1.3;
}

.logo-text p:first-child, .ipdc-title {
  font-weight: bold;
  color: #1a237e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.logo-text p:first-child {
  font-size: 12px;
}

.ipdc-title {
  font-size: 14px;
  letter-spacing: 0.8px;
  margin-bottom: 3px !important;
}

/* CENTER TITLE */
.certificate-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.4;
  /* margin: 0px 350px 0px; */
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #099c38;
  text-align: center;
}

/* HEADER BOTTOM */
.header-bottom {
   font-family: 'Times New Roman', Times, serif; /* Classic formal font */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 10px;
  color: #000;
  /* padding: 10px 50px; */
   /* padding-right: 10%; Add this line */
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
}

.header-bottom div {
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 12px;
  color: #000;
  /* padding: 10px 50px; */
   /* padding-right: 10%; Add this line */
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .left-logo {
    width: 180px;
  }
  
  .right-logo {
    width: 300px;
  }
  
  .certificate-title {
    margin: 0px 100px 10px;
  }
}

@media (max-width: 1024px) {
  .left-logo, .right-logo {
    width: 20%;
  }
  
  .right-logo img {
    height: 90px;
    max-width: 180px;
  }
  
  .certificate-title {
    margin: 60px 200px 20px;
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .certificate-container {
    padding: 10px;
  }
  
  .header-top {
    flex-direction: column;
    align-items: center;
    min-height: auto;
    position: relative;
    margin-bottom: 20px;
  }
  
  .left-logo, .right-logo {
    position: static;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .left-logo .logo-container,
  .right-logo .logo-container {
    flex-direction: row;
    gap: 15px;
    max-width: 100%;
  }
  
  .right-logo img {
    height: 80px;
    max-width: 150px;
  }
  
  .certificate-title {
    margin: 0 0;
    font-size: 14px;
    padding: 0 10px;
  }
  
 
  
  .header-bottom div {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .certificate-title {
    font-size: 12px;
  }
  
  .logo-star {
    height: 50px;
  }
  
  .right-logo img {
    height: 60px;
    max-width: 120px;
  }
  
  .logo-text p, .ipdc-text p {
    font-size: 10px;
  }
  
  .ipdc-title {
    font-size: 11px;
  }
}

/* BODY STYLES */
.certificate-body {
  /* background-color: white; */
  padding: 0px;
  /* border: 2px solid #333; */
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  margin-bottom: 2px;
  /* border-radius: 8px; */
}

/* GRID & INFO SECTIONS */
.info-grid {
  margin-bottom: 0px 25px;
  width: 100%;
}

.info-row, .signature-row {
  display: flex;
  /* margin-bottom: 1px; */
  /* padding: 8px 0;
  align-items: center;
  min-height: 15px; */
}
.info-row{
   margin-bottom: 1px;
}

.info-row {
  border-bottom: 1px dotted #ccc;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}

.info-label, .signature-row span:first-child {
  font-weight: bold;
  color: #0f0f0f;
  font-size: 11px;
  min-width: 180px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
  width: 180px;
}

.signature-row span:first-child {
  width: 150px;
}

.info-value, .signature-value {
  flex: 1 1;
  color: #2c3e50;
  padding-left: 10px;
  font-size: 14px;
  min-height: 20px;
}

.signature-value {
  max-width: 300px;
  text-align: right;
  font-style: italic;
  padding: 4px 0;
}

/* SECTIONS WITH PADDING AND BACKGROUND */
.permission-section, .notice-section, .drawings-section, 
.conditions-section, .coordinates-section, .permit-details {
  padding:1px 2px;
  color: #2c3e50;
  margin-bottom: 0px;
}

.permission-section {
  background-color: #f1f8ff;
  border-left: 4px solid #007bff;
  text-align: center;
}

.notice-section {
  background-color: #fff8e1;
  border: 1px solid #ffeaa7;
  margin-top: 20px;
}

.drawings-section, .coordinates-section, .permit-details {
  /* background-color: #f8f9fa; */
  border: 1px solid #dee2e6;
}


/* HEADERS WITH BOTTOM BORDER */
.notice-section h3, .drawings-section h3, 
.coordinates-section h4, .form-controls h3 {
  color: #2c3e50;
  /* margin-bottom: 2px; */
  font-size: 12px;
  border-bottom: 1px solid; 
  padding-bottom: 2px;
  /* margin-top: 10px; */
  font-size:10px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}
.info-label{
  color:#101010;
}
.notice-section h3 {
  color: #d35400;
  border-bottom-color: #ffb142;
}

.drawings-section h3 {
  border-bottom-color: #3498db;
}

.coordinates-section h4 {
  border-bottom-color: #34495e;
}

.form-controls h3 {
  border-bottom-color: #3498db;
  font-size: 18px;
}
.fa{
  color: #60caf7;
}

/* LISTS */
.notice-list, .conditions-list {
  margin-left: 0px;
  margin-bottom: 1px;
  padding-right: 0px;
}

.notice-list li, .conditions-list li {
  color:#000;
  margin-bottom: 1px;
  line-height: 1.5;
  font-size: 10px;
  position: relative;
  padding-left: 5px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}

.notice-list li::before, .conditions-list li::before {
  content: '';
  position: absolute;
  left: -15px;
  top: 8px;
  width: 6px;
  height: 6px;
  /* background-color: #3498db; */
  /* border-radius: 50%; */
}

/* PERMISSION TEXT */
.permission-text {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

.permitted {
  font-weight: bold;
  color: #1b3584;
  margin-left: 5px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* PERMIT DETAILS GRID */
.permit-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.permit-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.permit-row span:first-child {
  font-weight: bold;
  margin-bottom: 5px;
  color: #666;
  font-size: 13px;
  text-transform: uppercase;
}

.permit-row span:last-child {
  color: #2c3e50;
  font-size: 14px;
  min-height: 20px;
  padding: 4px 0;
}
.table-row{
  background-color:#D3D3D3;
}
/* TABLES */
.drawings-table, .coordinates-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}

.drawings-table {
  margin-bottom: 0px;
}
.coordinates-table {
  margin-bottom: 0px;
  margin-top: 0px;
}
.heading {

color: #000;
font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}
.after-check
{
  color: #000;
font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}
.drawings-table th, .drawings-table td
{
  border: 1px solid #101010; 
  color:#000;
  padding: 0px 1px;
  text-align: center;
  vertical-align: middle;
   font-size: 10px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}
.coordinates-table th, .coordinates-table td {
  /* border: 1px solid #ddd; */
  color:#000;
  padding: 0px 12px;
  text-align: center;
  vertical-align: middle;
   font-size: 10px;
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */
}

.drawings-table th {
  padding: 12px;
}

.coordinates-table th, .coordinates-table td {
  padding: 2px;
}

.drawings-table th, .coordinates-table th {
  font-family: 'Times New Roman', Times, serif; /* Classic formal font */

  /* background-color: #2c3e50; */
  color: #000;
  font-weight: bold;
  font-size: 12px;
}

.coordinates-table th {
  background-color: #34495e;
  font-size: 12px;
}

.drawings-table td, .coordinates-table td {
  background-color: white;
}

/* CHECKMARK */
.checkmark {
  width: 24px;
  height: 24px;
  border: 2px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.checkmark:hover {
  border-color: #3498db;
  transform: scale(1.05);
}

.checkmark.checked {
  background-color: #4CAF50;
  color: white;
  border-color: #4CAF50;
}

/* COORDINATE INPUT */
.coordinate-input {
  width: 95%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 3px;
  text-align: center;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  transition: border-color 0.2s;
}

.coordinate-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

/* DECISION SECTION */
.decision-section {
  text-align: center;
  margin: 2px 0;
  padding: 5px;
  /* background-color: #2c3e50; */
  border: 1px solid #0b0b0b;
  color: white;
  /* border-radius: 4px; */
}

.decision-section h3 {
  margin: 0;
  font-size: 12px;
  /* font-weight: 500; */
  letter-spacing: 0.5px;
   color: #000;
}

/* AUTHORITY TEXT */
.authority-text {
font-family: 'Times New Roman', Times, serif; /* Classic formal font */
  color: #000;
  line-height: 1.6;
  margin: 0;
  padding-top: 0px;
  border-top: 1px solid #ddd;
  font-size: 10px;
  text-align: justify;
}

/* SIGNATURES */
.signatures-section {
  margin-top: 0px 40px;
  /* padding-top: 20px; */
  /* border-top: 2px solid #333; */
}

.signature-row {
  border-bottom: 1px dashed #ccc;
  padding-bottom: 10px;
}

/* FORM CONTROLS */
.form-controls {
  margin-top: 40px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  /* border: 2px solid #dee2e6; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
}

.input-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.input-grid input {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
}

.input-grid input:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
  background-color: white;
}

.input-grid input::placeholder {
  color: #95a5a6;
  font-style: italic;
}

/* RESET BUTTON */
.reset-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.2s;
  display: block;
  margin: 0 auto;
  min-width: 200px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.reset-btn:hover {
  background-color: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.reset-btn:active {
  transform: translateY(0);
}

/* PRINT STYLES */
@media print {
  .form-controls, .reset-btn {
    display: none !important;
  }
  
  .certificate-container {
    padding: 0 !important;
    margin: 0 !important;
    background-color: white !important;
    max-width: 100% !important;
    min-height: auto !important;
  }
  
  .certificate-body {
    border: none !important;
    box-shadow: none !important;
    padding: 20px !important;
    margin: 0 !important;
  }
  
  .checkmark {
    border: 2px solid #333 !important;
    print-color-adjust: exact !important;
  }
  
  .checkmark.checked {
    background-color: #4CAF50 !important;
    color: white !important;
    border-color: #4CAF50 !important;
  }
  
  .coordinate-input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  
  body {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  table {
    page-break-inside: avoid;
  }
  
  .certificate-container {
    page-break-before: avoid;
    page-break-after: avoid;
  }
}

/* ANIMATIONS & EFFECTS */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.input-grid input {
  animation: fadeIn 0.3s ease-out;
}

/* CUSTOM SCROLLBAR */
.certificate-container::-webkit-scrollbar {
  width: 8px;
}

.certificate-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.certificate-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.certificate-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* HOVER EFFECTS */
.checkmark:hover, .reset-btn:hover {
  transition: all 0.2s ease-in-out;
}

/* FOCUS STATES */
.checkmark:focus, .reset-btn:focus, .input-grid input:focus {
  outline: 2px solid #3498db;
  outline-offset: 2px;
}
.signature-input {
  width: 100%;
  border: none;
  background: transparent;
  border-bottom: 1px solid #666;
  font-size: 14px;
  padding: 3px 0;
  color: #333;
  text-align: left;
  font-family: inherit;
}

.signature-input:focus {
  outline: none;
  border-bottom-color: #007bff;
}

.signature-input::placeholder {
  color: #999;
}
/* SIGNATURES SECTION - 3 COLUMNS SIDE BY SIDE */
.signatures-section {
  margin-top: 0px  40px;
  /* padding: 20px; */
  /* border: 1px solid #333;
  background-color: #f8f9fa; */
  border-radius: 4px;
}

.signature-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.signature-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 0 15px; */
  min-width: 150px;
}

.signature-label {
  /* font-weight: bold; */
  color: #000;
  font-size: 13px;
  margin-bottom: 10px; /* Space for signature above line */
  text-align: center;
}

.signature-line {
  color: #333;
  font-size: 14px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #666;
  padding-bottom: 5px;
  min-height: 25px;
}

/* If you want the name to look different */
.signature-column:nth-child(2) .signature-line {
  font-style: italic;
}

/* For responsive design */
@media (max-width: 768px) {
  .signature-row {
    flex-direction: column;
    gap: 30px;
  }
  
  .signature-column {
    width: 100%;
  }
}
/* TWO-COLUMN LAYOUT */
.two-column-layout {
  display: flex;
  position: relative;
  gap: 30px;
  min-height: 30vh;
}

.column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* GREEN VERTICAL DIVIDER LINE */
.vertical-divider {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #28a745;
  transform: translateX(-50%);
  z-index: 1;
}

/* OPTIONAL: Add decorative elements to the divider */
.vertical-divider::before {
  content: '';
  position: absolute;
  top: 10px;
  /* left: -5px;
  right: -5px;
  height: 15px; */
  background-color: #28a745;
  border-radius: 10px;
}

.vertical-divider::after {
  content: '';
  position: absolute;
  bottom: 10px;
  /* left: -5px;
  right: -5px;
  height: 15px; */
  background-color: #28a745;
  border-radius: 10px;
}

/* Adjust sections for two-column layout */
.left-column .permit-details {
  grid-template-columns: 1fr;
  gap: 1px;
  margin-bottom: 20px;

}
.permit-details {
 margin-bottom: 20px;
}
/* Authority text moved to right column */
.authority-section {
  background-color: #fff8e1;
  border: 1px solid #ffeaa7;
  padding: 1px;
  border-radius: 4px;
  margin-bottom: 0px;
  margin-top: 5px;
}

/* Adjust spacing for two columns */
.left-column .info-section,
.left-column .permission-section,
.left-column .permit-details,
.left-column .notice-section,
.right-column .authority-section,
.right-column .drawings-section,
.right-column .conditions-section,
.right-column .decision-section,
.right-column .coordinates-section,
.right-column .signatures-section {
  margin: 0;
}

/* Ensure proper content distribution */
.left-column {
  padding-right: 15px;
}

.right-column {
  padding-left: 15px;
}

/* Responsive design for two columns */
@media (max-width: 1024px) {
  .two-column-layout {
    flex-direction: column;
    gap: 20px;
  }
  
  .vertical-divider {
    display: none;
  }
  
  .left-column,
  .right-column {
    padding: 0;
  }
}
/* COORDINATES SECTION - MATCHING SCREENSHOT */
.coordinates-section {
  margin: 2px 0;
  border: 1px solid #333;
  padding: 0px;
  background-color: white;
  border-radius: 4px;
}

.coordinates-section h4 {
  color: #000;
  margin: 0 0 5px 0;
  font-size: 12px;
  /* font-weight: bold; */
  text-align: center;
  /* border-bottom: 2px solid #333; */
  padding-bottom: 0px;
}

.coordinates-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.coordinates-table th {
  background-color: #f8f9fa;
  color: #000;
  font-weight: bold;
  padding: 0px;
  border: 1px solid #333;
  text-align: center;
  width: 50%;
}

.coordinates-table td {
  /* border: 1px solid #333; */
  padding: 2px;
  background-color: white;
}

.coordinate-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 14px;
  font-family: 'Courier New', monospace;
  text-align: center;
  padding: 5px;
  color: #333;
}

.coordinate-input:focus {
  outline: none;
  background-color: #f0f8ff;
}

/* If you want the comma to be part of the input value */
.coordinates-table td:first-child .coordinate-input {
  text-align: right;
  padding-right: 5px;
}

.coordinates-table td:first-child::after {
  content: ',';
  position: absolute;
  margin-left: 2px;
}

/* Alternative: Add comma in the input value directly */
.coordinates-table td:first-child {
  position: relative;
}
.coordinate {
  display: block;
  font-size: 10px;
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  font-family: 'Times New Roman', Times, serif;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Views/LandInfraDevelopment/DesignAndConstructionView/Forms/OccupancyPermissionCertificate.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;EAC5C,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;;;EAGR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;GACG,4CAA4C,EAAE,wBAAwB;EACvE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,wBAAwB;GACvB,sCAAsC;EACvC,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,4CAA4C,EAAE,wBAAwB;EACtE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,wBAAwB;GACvB,sCAAsC;EACvC,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;;;EAIA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;EAC5B,8CAA8C;EAC9C,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB;;qBAEmB;AACrB;AACA;GACG,kBAAkB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C,EAAE,wBAAwB;AACxE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4CAA4C,EAAE,wBAAwB;EACtE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;;AAGA,+BAA+B;AAC/B;;EAEE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,4CAA4C,EAAE,wBAAwB;AACxE;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C,EAAE,wBAAwB;AACxE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,4CAA4C,EAAE,wBAAwB;AACxE;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;AAEA,WAAW;AACX,4CAA4C,EAAE,wBAAwB;AACtE;AACA;;EAEE,WAAW;AACb,4CAA4C,EAAE,wBAAwB;AACtE;AACA;;EAEE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;GACrB,eAAe;EAChB,4CAA4C,EAAE,wBAAwB;AACxE;AACA;EACE,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;GACrB,eAAe;EAChB,4CAA4C,EAAE,wBAAwB;AACxE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C,EAAE,wBAAwB;;EAEtE,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,qBAAqB;GACpB,WAAW;AACd;;AAEA,mBAAmB;AACnB;AACA,4CAA4C,EAAE,wBAAwB;EACpE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,kCAAkC;IAClC,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IAEjC,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;AACA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,mBAAmB;EACnB;8BAC4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mBAAmB,EAAE,mCAAmC;EACxD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT;;iBAEe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ;;iBAEe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,QAAQ;EACR,mBAAmB;;AAErB;AACA;CACC,mBAAmB;AACpB;AACA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;;;;;;;;;;EAUE,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,UAAU;EACZ;AACF;AACA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,4CAA4C;EAC5C,kBAAkB;AACpB","sourcesContent":["/* BuildingPermissionCertificate.css */\r\n\r\n.certificate-container {\r\n  max-width: 1200px;\r\n  margin: 2.5% 5% 5% 5%;\r\n  padding: 0px 20px;\r\n  font-family: 'Times New Roman', Times, serif;\r\n  background-color: #f8f9fa;\r\n  min-height: 80vh;\r\n  border: 8px solid #29196f; \r\n}\r\n\r\n.certificate-header {\r\n  text-align: center;\r\n  margin-bottom: 4px;\r\n  border-bottom: 3px double #333;\r\n  /* padding-bottom: 20px; */\r\n  position: relative;\r\n  margin-top: 2px;\r\n}\r\n\r\n.header-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  min-height: 70px;\r\n  position: relative;\r\n  margin-top: 0px; \r\n}\r\n\r\n/* LOGO STYLES */\r\n.left-logo, .right-logo {\r\n  position: absolute;\r\n  top: 0;\r\n  width: 200px;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.left-logo {\r\n  left: 0;\r\n}\r\n\r\n.right-logo {\r\n  right: 0;\r\n  \r\n  \r\n  justify-content: flex-end;\r\n}\r\n\r\n.logo-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 8px;\r\n  padding: 5px;\r\n}\r\n\r\n.right-logo .logo-container {\r\n  gap: 12px;\r\n  /* padding: 10px; */\r\n}\r\n\r\n.logo-star {\r\n  height: 50px;\r\n  width: 50px;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n.right-logo img {\r\n  /* height: 120px; */\r\n  width: auto;\r\n  max-width: 250px;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n.logo-text, .ipdc-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  max-width: 150px;\r\n}\r\n\r\n.ipdc-text {\r\n  max-width: 300px;\r\n}\r\n\r\n.logo-text p, .ipdc-text p {\r\n  margin: 0;\r\n  line-height: 1.2;\r\n  color: #2c3e50;\r\n  font-weight: 500;\r\n}\r\n\r\n.logo-text p {\r\n  font-size: 11px;\r\n}\r\n\r\n.ipdc-text p {\r\n  font-size: 13px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.logo-text p:first-child, .ipdc-title {\r\n  font-weight: bold;\r\n  color: #1a237e;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.logo-text p:first-child {\r\n  font-size: 12px;\r\n}\r\n\r\n.ipdc-title {\r\n  font-size: 14px;\r\n  letter-spacing: 0.8px;\r\n  margin-bottom: 3px !important;\r\n}\r\n\r\n/* CENTER TITLE */\r\n.certificate-title {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  line-height: 1.4;\r\n  /* margin: 0px 350px 0px; */\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  color: #099c38;\r\n  text-align: center;\r\n}\r\n\r\n/* HEADER BOTTOM */\r\n.header-bottom {\r\n   font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  font-size: 10px;\r\n  color: #000;\r\n  /* padding: 10px 50px; */\r\n   /* padding-right: 10%; Add this line */\r\n  gap: 2px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.header-bottom div {\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  font-size: 12px;\r\n  color: #000;\r\n  /* padding: 10px 50px; */\r\n   /* padding-right: 10%; Add this line */\r\n  gap: 2px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 1200px) {\r\n  .left-logo {\r\n    width: 180px;\r\n  }\r\n  \r\n  .right-logo {\r\n    width: 300px;\r\n  }\r\n  \r\n  .certificate-title {\r\n    margin: 0px 100px 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .left-logo, .right-logo {\r\n    width: 20%;\r\n  }\r\n  \r\n  .right-logo img {\r\n    height: 90px;\r\n    max-width: 180px;\r\n  }\r\n  \r\n  .certificate-title {\r\n    margin: 60px 200px 20px;\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .certificate-container {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .header-top {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    min-height: auto;\r\n    position: relative;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .left-logo, .right-logo {\r\n    position: static;\r\n    width: 100%;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .left-logo .logo-container,\r\n  .right-logo .logo-container {\r\n    flex-direction: row;\r\n    gap: 15px;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .right-logo img {\r\n    height: 80px;\r\n    max-width: 150px;\r\n  }\r\n  \r\n  .certificate-title {\r\n    margin: 0 0;\r\n    font-size: 14px;\r\n    padding: 0 10px;\r\n  }\r\n  \r\n \r\n  \r\n  .header-bottom div {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .certificate-title {\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .logo-star {\r\n    height: 50px;\r\n  }\r\n  \r\n  .right-logo img {\r\n    height: 60px;\r\n    max-width: 120px;\r\n  }\r\n  \r\n  .logo-text p, .ipdc-text p {\r\n    font-size: 10px;\r\n  }\r\n  \r\n  .ipdc-title {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* BODY STYLES */\r\n.certificate-body {\r\n  /* background-color: white; */\r\n  padding: 0px;\r\n  /* border: 2px solid #333; */\r\n  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */\r\n  margin-bottom: 2px;\r\n  /* border-radius: 8px; */\r\n}\r\n\r\n/* GRID & INFO SECTIONS */\r\n.info-grid {\r\n  margin-bottom: 0px 25px;\r\n  width: 100%;\r\n}\r\n\r\n.info-row, .signature-row {\r\n  display: flex;\r\n  /* margin-bottom: 1px; */\r\n  /* padding: 8px 0;\r\n  align-items: center;\r\n  min-height: 15px; */\r\n}\r\n.info-row{\r\n   margin-bottom: 1px;\r\n}\r\n\r\n.info-row {\r\n  border-bottom: 1px dotted #ccc;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n\r\n.info-label, .signature-row span:first-child {\r\n  font-weight: bold;\r\n  color: #0f0f0f;\r\n  font-size: 11px;\r\n  min-width: 180px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n  width: 180px;\r\n}\r\n\r\n.signature-row span:first-child {\r\n  width: 150px;\r\n}\r\n\r\n.info-value, .signature-value {\r\n  flex: 1;\r\n  color: #2c3e50;\r\n  padding-left: 10px;\r\n  font-size: 14px;\r\n  min-height: 20px;\r\n}\r\n\r\n.signature-value {\r\n  max-width: 300px;\r\n  text-align: right;\r\n  font-style: italic;\r\n  padding: 4px 0;\r\n}\r\n\r\n/* SECTIONS WITH PADDING AND BACKGROUND */\r\n.permission-section, .notice-section, .drawings-section, \r\n.conditions-section, .coordinates-section, .permit-details {\r\n  padding:1px 2px;\r\n  color: #2c3e50;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.permission-section {\r\n  background-color: #f1f8ff;\r\n  border-left: 4px solid #007bff;\r\n  text-align: center;\r\n}\r\n\r\n.notice-section {\r\n  background-color: #fff8e1;\r\n  border: 1px solid #ffeaa7;\r\n  margin-top: 20px;\r\n}\r\n\r\n.drawings-section, .coordinates-section, .permit-details {\r\n  /* background-color: #f8f9fa; */\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n\r\n/* HEADERS WITH BOTTOM BORDER */\r\n.notice-section h3, .drawings-section h3, \r\n.coordinates-section h4, .form-controls h3 {\r\n  color: #2c3e50;\r\n  /* margin-bottom: 2px; */\r\n  font-size: 12px;\r\n  border-bottom: 1px solid; \r\n  padding-bottom: 2px;\r\n  /* margin-top: 10px; */\r\n  font-size:10px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n.info-label{\r\n  color:#101010;\r\n}\r\n.notice-section h3 {\r\n  color: #d35400;\r\n  border-bottom-color: #ffb142;\r\n}\r\n\r\n.drawings-section h3 {\r\n  border-bottom-color: #3498db;\r\n}\r\n\r\n.coordinates-section h4 {\r\n  border-bottom-color: #34495e;\r\n}\r\n\r\n.form-controls h3 {\r\n  border-bottom-color: #3498db;\r\n  font-size: 18px;\r\n}\r\n.fa{\r\n  color: #60caf7;\r\n}\r\n\r\n/* LISTS */\r\n.notice-list, .conditions-list {\r\n  margin-left: 0px;\r\n  margin-bottom: 1px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.notice-list li, .conditions-list li {\r\n  color:#000;\r\n  margin-bottom: 1px;\r\n  line-height: 1.5;\r\n  font-size: 10px;\r\n  position: relative;\r\n  padding-left: 5px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n\r\n.notice-list li::before, .conditions-list li::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -15px;\r\n  top: 8px;\r\n  width: 6px;\r\n  height: 6px;\r\n  /* background-color: #3498db; */\r\n  /* border-radius: 50%; */\r\n}\r\n\r\n/* PERMISSION TEXT */\r\n.permission-text {\r\n  font-size: 16px;\r\n  margin: 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.permitted {\r\n  font-weight: bold;\r\n  color: #1b3584;\r\n  margin-left: 5px;\r\n  font-size: 18px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n/* PERMIT DETAILS GRID */\r\n.permit-details {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n.permit-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.permit-row span:first-child {\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n  color: #666;\r\n  font-size: 13px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.permit-row span:last-child {\r\n  color: #2c3e50;\r\n  font-size: 14px;\r\n  min-height: 20px;\r\n  padding: 4px 0;\r\n}\r\n.table-row{\r\n  background-color:#D3D3D3;\r\n}\r\n/* TABLES */\r\n.drawings-table, .coordinates-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 10px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n\r\n.drawings-table {\r\n  margin-bottom: 0px;\r\n}\r\n.coordinates-table {\r\n  margin-bottom: 0px;\r\n  margin-top: 0px;\r\n}\r\n.heading {\r\n\r\ncolor: #000;\r\nfont-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n.after-check\r\n{\r\n  color: #000;\r\nfont-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n.drawings-table th, .drawings-table td\r\n{\r\n  border: 1px solid #101010; \r\n  color:#000;\r\n  padding: 0px 1px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n   font-size: 10px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n.coordinates-table th, .coordinates-table td {\r\n  /* border: 1px solid #ddd; */\r\n  color:#000;\r\n  padding: 0px 12px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n   font-size: 10px;\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n}\r\n\r\n.drawings-table th {\r\n  padding: 12px;\r\n}\r\n\r\n.coordinates-table th, .coordinates-table td {\r\n  padding: 2px;\r\n}\r\n\r\n.drawings-table th, .coordinates-table th {\r\n  font-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n\r\n  /* background-color: #2c3e50; */\r\n  color: #000;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n}\r\n\r\n.coordinates-table th {\r\n  background-color: #34495e;\r\n  font-size: 12px;\r\n}\r\n\r\n.drawings-table td, .coordinates-table td {\r\n  background-color: white;\r\n}\r\n\r\n/* CHECKMARK */\r\n.checkmark {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 2px solid #ddd;\r\n  background: white;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n  user-select: none;\r\n}\r\n\r\n.checkmark:hover {\r\n  border-color: #3498db;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.checkmark.checked {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n  border-color: #4CAF50;\r\n}\r\n\r\n/* COORDINATE INPUT */\r\n.coordinate-input {\r\n  width: 95%;\r\n  padding: 6px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 3px;\r\n  text-align: center;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 13px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.coordinate-input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\r\n}\r\n\r\n/* DECISION SECTION */\r\n.decision-section {\r\n  text-align: center;\r\n  margin: 2px 0;\r\n  padding: 5px;\r\n  /* background-color: #2c3e50; */\r\n  border: 1px solid #0b0b0b;\r\n  color: white;\r\n  /* border-radius: 4px; */\r\n}\r\n\r\n.decision-section h3 {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  /* font-weight: 500; */\r\n  letter-spacing: 0.5px;\r\n   color: #000;\r\n}\r\n\r\n/* AUTHORITY TEXT */\r\n.authority-text {\r\nfont-family: 'Times New Roman', Times, serif; /* Classic formal font */\r\n  color: #000;\r\n  line-height: 1.6;\r\n  margin: 0;\r\n  padding-top: 0px;\r\n  border-top: 1px solid #ddd;\r\n  font-size: 10px;\r\n  text-align: justify;\r\n}\r\n\r\n/* SIGNATURES */\r\n.signatures-section {\r\n  margin-top: 0px 40px;\r\n  /* padding-top: 20px; */\r\n  /* border-top: 2px solid #333; */\r\n}\r\n\r\n.signature-row {\r\n  border-bottom: 1px dashed #ccc;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n/* FORM CONTROLS */\r\n.form-controls {\r\n  margin-top: 40px;\r\n  padding: 20px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  /* border: 2px solid #dee2e6; */\r\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\r\n}\r\n\r\n.input-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n  gap: 15px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.input-grid input {\r\n  padding: 10px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.input-grid input:focus {\r\n  outline: none;\r\n  border-color: #4CAF50;\r\n  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);\r\n  background-color: white;\r\n}\r\n\r\n.input-grid input::placeholder {\r\n  color: #95a5a6;\r\n  font-style: italic;\r\n}\r\n\r\n/* RESET BUTTON */\r\n.reset-btn {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 30px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  transition: all 0.2s;\r\n  display: block;\r\n  margin: 0 auto;\r\n  min-width: 200px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.reset-btn:hover {\r\n  background-color: #c82333;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.reset-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* PRINT STYLES */\r\n@media print {\r\n  .form-controls, .reset-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .certificate-container {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    background-color: white !important;\r\n    max-width: 100% !important;\r\n    min-height: auto !important;\r\n  }\r\n  \r\n  .certificate-body {\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n    padding: 20px !important;\r\n    margin: 0 !important;\r\n  }\r\n  \r\n  .checkmark {\r\n    border: 2px solid #333 !important;\r\n    -webkit-print-color-adjust: exact !important;\r\n    print-color-adjust: exact !important;\r\n  }\r\n  \r\n  .checkmark.checked {\r\n    background-color: #4CAF50 !important;\r\n    color: white !important;\r\n    border-color: #4CAF50 !important;\r\n  }\r\n  \r\n  .coordinate-input {\r\n    border: none !important;\r\n    background: transparent !important;\r\n    box-shadow: none !important;\r\n    padding: 0 !important;\r\n  }\r\n  \r\n  body {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n  \r\n  table {\r\n    page-break-inside: avoid;\r\n  }\r\n  \r\n  .certificate-container {\r\n    page-break-before: avoid;\r\n    page-break-after: avoid;\r\n  }\r\n}\r\n\r\n/* ANIMATIONS & EFFECTS */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.input-grid input {\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n/* CUSTOM SCROLLBAR */\r\n.certificate-container::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.certificate-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.certificate-container::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 4px;\r\n}\r\n\r\n.certificate-container::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* HOVER EFFECTS */\r\n.checkmark:hover, .reset-btn:hover {\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n/* FOCUS STATES */\r\n.checkmark:focus, .reset-btn:focus, .input-grid input:focus {\r\n  outline: 2px solid #3498db;\r\n  outline-offset: 2px;\r\n}\r\n.signature-input {\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  border-bottom: 1px solid #666;\r\n  font-size: 14px;\r\n  padding: 3px 0;\r\n  color: #333;\r\n  text-align: left;\r\n  font-family: inherit;\r\n}\r\n\r\n.signature-input:focus {\r\n  outline: none;\r\n  border-bottom-color: #007bff;\r\n}\r\n\r\n.signature-input::placeholder {\r\n  color: #999;\r\n}\r\n/* SIGNATURES SECTION - 3 COLUMNS SIDE BY SIDE */\r\n.signatures-section {\r\n  margin-top: 0px  40px;\r\n  /* padding: 20px; */\r\n  /* border: 1px solid #333;\r\n  background-color: #f8f9fa; */\r\n  border-radius: 4px;\r\n}\r\n\r\n.signature-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.signature-column {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  /* padding: 0 15px; */\r\n  min-width: 150px;\r\n}\r\n\r\n.signature-label {\r\n  /* font-weight: bold; */\r\n  color: #000;\r\n  font-size: 13px;\r\n  margin-bottom: 10px; /* Space for signature above line */\r\n  text-align: center;\r\n}\r\n\r\n.signature-line {\r\n  color: #333;\r\n  font-size: 14px;\r\n  width: 100%;\r\n  text-align: center;\r\n  border-bottom: 1px solid #666;\r\n  padding-bottom: 5px;\r\n  min-height: 25px;\r\n}\r\n\r\n/* If you want the name to look different */\r\n.signature-column:nth-child(2) .signature-line {\r\n  font-style: italic;\r\n}\r\n\r\n/* For responsive design */\r\n@media (max-width: 768px) {\r\n  .signature-row {\r\n    flex-direction: column;\r\n    gap: 30px;\r\n  }\r\n  \r\n  .signature-column {\r\n    width: 100%;\r\n  }\r\n}\r\n/* TWO-COLUMN LAYOUT */\r\n.two-column-layout {\r\n  display: flex;\r\n  position: relative;\r\n  gap: 30px;\r\n  min-height: 30vh;\r\n}\r\n\r\n.column {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n/* GREEN VERTICAL DIVIDER LINE */\r\n.vertical-divider {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background-color: #28a745;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n}\r\n\r\n/* OPTIONAL: Add decorative elements to the divider */\r\n.vertical-divider::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 10px;\r\n  /* left: -5px;\r\n  right: -5px;\r\n  height: 15px; */\r\n  background-color: #28a745;\r\n  border-radius: 10px;\r\n}\r\n\r\n.vertical-divider::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 10px;\r\n  /* left: -5px;\r\n  right: -5px;\r\n  height: 15px; */\r\n  background-color: #28a745;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Adjust sections for two-column layout */\r\n.left-column .permit-details {\r\n  grid-template-columns: 1fr;\r\n  gap: 1px;\r\n  margin-bottom: 20px;\r\n\r\n}\r\n.permit-details {\r\n margin-bottom: 20px;\r\n}\r\n/* Authority text moved to right column */\r\n.authority-section {\r\n  background-color: #fff8e1;\r\n  border: 1px solid #ffeaa7;\r\n  padding: 1px;\r\n  border-radius: 4px;\r\n  margin-bottom: 0px;\r\n  margin-top: 5px;\r\n}\r\n\r\n/* Adjust spacing for two columns */\r\n.left-column .info-section,\r\n.left-column .permission-section,\r\n.left-column .permit-details,\r\n.left-column .notice-section,\r\n.right-column .authority-section,\r\n.right-column .drawings-section,\r\n.right-column .conditions-section,\r\n.right-column .decision-section,\r\n.right-column .coordinates-section,\r\n.right-column .signatures-section {\r\n  margin: 0;\r\n}\r\n\r\n/* Ensure proper content distribution */\r\n.left-column {\r\n  padding-right: 15px;\r\n}\r\n\r\n.right-column {\r\n  padding-left: 15px;\r\n}\r\n\r\n/* Responsive design for two columns */\r\n@media (max-width: 1024px) {\r\n  .two-column-layout {\r\n    flex-direction: column;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .vertical-divider {\r\n    display: none;\r\n  }\r\n  \r\n  .left-column,\r\n  .right-column {\r\n    padding: 0;\r\n  }\r\n}\r\n/* COORDINATES SECTION - MATCHING SCREENSHOT */\r\n.coordinates-section {\r\n  margin: 2px 0;\r\n  border: 1px solid #333;\r\n  padding: 0px;\r\n  background-color: white;\r\n  border-radius: 4px;\r\n}\r\n\r\n.coordinates-section h4 {\r\n  color: #000;\r\n  margin: 0 0 5px 0;\r\n  font-size: 12px;\r\n  /* font-weight: bold; */\r\n  text-align: center;\r\n  /* border-bottom: 2px solid #333; */\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.coordinates-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n}\r\n\r\n.coordinates-table th {\r\n  background-color: #f8f9fa;\r\n  color: #000;\r\n  font-weight: bold;\r\n  padding: 0px;\r\n  border: 1px solid #333;\r\n  text-align: center;\r\n  width: 50%;\r\n}\r\n\r\n.coordinates-table td {\r\n  /* border: 1px solid #333; */\r\n  padding: 2px;\r\n  background-color: white;\r\n}\r\n\r\n.coordinate-input {\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  font-size: 14px;\r\n  font-family: 'Courier New', monospace;\r\n  text-align: center;\r\n  padding: 5px;\r\n  color: #333;\r\n}\r\n\r\n.coordinate-input:focus {\r\n  outline: none;\r\n  background-color: #f0f8ff;\r\n}\r\n\r\n/* If you want the comma to be part of the input value */\r\n.coordinates-table td:first-child .coordinate-input {\r\n  text-align: right;\r\n  padding-right: 5px;\r\n}\r\n\r\n.coordinates-table td:first-child::after {\r\n  content: ',';\r\n  position: absolute;\r\n  margin-left: 2px;\r\n}\r\n\r\n/* Alternative: Add comma in the input value directly */\r\n.coordinates-table td:first-child {\r\n  position: relative;\r\n}\r\n.coordinate {\r\n  display: block;\r\n  font-size: 10px;\r\n  color: #2c3e50;\r\n  border-bottom: 2px solid #3498db;\r\n  font-family: 'Times New Roman', Times, serif;\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
